<div
  class="relative flex flex-col rounded-3xl border border-gray-6 bg-gray-1 p-8 shadow-sm overflow-hidden border-l-[6px] border-l-primary/40 min-h-[220px]"
>
  <div class="flex-1">
    <div class="flex items-center justify-between mb-2">
      <ngx-skeleton-loader
        [theme]="{ width: '180px', height: '28px', 'border-radius': '8px', margin: '0' }"
        animation="pulse"
      />
      <ngx-skeleton-loader
        [theme]="{ width: '28px', height: '28px', 'border-radius': '50%', margin: '0' }"
        animation="pulse"
      />
    </div>
    <div class="flex items-center gap-2 mb-6 mt-3">
      <ngx-skeleton-loader
        [theme]="{ width: '20px', height: '20px', 'border-radius': '4px', margin: '0' }"
        animation="pulse"
      />
      <ngx-skeleton-loader
        [theme]="{ width: '200px', height: '18px', 'border-radius': '6px', margin: '0' }"
        animation="pulse"
      />
    </div>
    <ngx-skeleton-loader
      [theme]="{ width: '130px', height: '12px', 'border-radius': '4px', margin: '0' }"
      animation="pulse"
    />
  </div>
  <div class="mt-auto pt-6 border-t border-gray-3 flex items-center justify-between">
    <div class="flex flex-col gap-1">
      <ngx-skeleton-loader
        [theme]="{ width: '80px', height: '10px', 'border-radius': '4px', margin: '0' }"
        animation="pulse"
      />
      <ngx-skeleton-loader
        [theme]="{ width: '100px', height: '18px', 'border-radius': '6px', margin: '0' }"
        animation="pulse"
      />
    </div>
    <ngx-skeleton-loader
      [theme]="{ width: '48px', height: '48px', 'border-radius': '16px', margin: '0' }"
      animation="pulse"
    />
  </div>
</div>
